// import { useEffect, useRef, useState } from 'react'
// import { useFormik } from "formik";
// import { Helmet } from "react-helmet";
// import axios from "./../../helper/axios";
// import { useHistory } from 'react-router-dom';
// //for date picker calender need to import all tha files
// import { DateRangePicker } from 'react-date-range'
// import format from 'date-fns/format'
// import { addDays } from 'date-fns'
// import { subDays } from 'date-fns'
// import 'react-date-range/dist/styles.css'
// import 'react-date-range/dist/theme/default.css'
// import { saveAs } from 'file-saver';
// import * as XLSX from 'xlsx';
// import { GrDocumentDownload } from "react-icons/gr";
// import {FaFileDownload } from "react-icons/fa";
// import Apointmentsearch from '../../Component/Apointmentsearch';
// import { useUser } from '../../Provider';
// import Billingsearch from '../../Component/Billingsearch';
// import HospitalCodeSearch from '../../Component/HospitalCodeSearch';

// // import ReactHtmlTableToExcel from 'react-html-table-to-excel'
// //Each property is assigned an empty string as its initial value for this form field value
// const initialValues = {
//   opdnumber: "",
//   opdtype:"",
//   hospitalcode:""

//   };

// // Function to filter duplicate billnumbers and concatenate corresponding chargenames
// const filterAndConcatenateChargenames = (data) => {
//     const uniqueBillnumbers = [];
//     const filteredData = [];

//     data.forEach((item) => {
//       const { billnumber, chargename , patientid,patientname,subtotal,createdon,hospitalcode} = item;

//       if (!uniqueBillnumbers.includes(billnumber)) {
//         uniqueBillnumbers.push(billnumber);
//         filteredData.push({ billnumber, chargename,patientid,patientname,subtotal,createdon,hospitalcode });
//       } else {
//         const index = filteredData.findIndex((el) => el.billnumber === billnumber);
//         if (index !== -1) {
//           filteredData[index].chargename += `, ${chargename}`;
//         }
//       }
//     });

//     return filteredData;
//   };
// const BillingReport = () => {
//     //     The useHistory hook is typically used in a functional component within
//   //      a React application to access the browser's history object and manipulate the browser's URL programmatically.
//   // //**the history object to navigate the user to a different route by calling  return history.push('/'); */
//   const history = useHistory();
//   const {user, userHospitalcode, userrole1, isAuthRole,isAuthorized,gettokenId,token  } = useUser();
//   const [searchValue, setSearchValue] = useState("");
//   const handleSearchChange = (searchTerm) => {
//     console.log(searchTerm)
//     setSearchValue(searchTerm); // Update the searchValue state with the search term
//   };
//   const onSearchItems = (searchTerm) => {
//     console.log("------",searchTerm)
//    // setSearchValues(searchTerm);
//     setValues({
//       ...values,
//       hospitalcode: searchTerm.hospitalcode,
//       // Update other fields as needed
//     });
//   };
//   const { values, errors, touched, handleBlur, handleChange, handleReset, handleSubmit, setValues } =
//     useFormik({
//       initialValues,
//       onSubmit: async (values, action,) => {
//         try {
//           if (userHospitalcode !== undefined && userrole1 !== undefined) {
//           // It extracts the startDate from an array called range and calculates the timezoneOffset in milliseconds based on the user's local time zone.
//           // It creates a new Date object called adjustedDate, which is the original startDate adjusted by the timezoneOffset.
//           // It logs the adjusted date in the format "YYYY-MM-DD" using toISOString() and slice() methods.
//           // It creates a new FormData object called data.
//           // It appends two key-value pairs to the data object: "document" with the JSON stringified value of values,
//           // and "startDate" with the adjusted date in the format "YYYY-MM-DD".
//           // It appends another key-value pair "endDate" with the endDate from range in the format "YYYY-MM-DD".
//           const startDate = range[0].startDate;
//           const endDate = range[0].endDate;
//           const timezoneOffset = startDate.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
//           const adjustedDate = new Date(startDate.getTime() - timezoneOffset);
//           const adjustedDates = new Date(endDate.getTime() - timezoneOffset);
//           console.log(adjustedDate.toISOString().slice(0, 10));
//           //when i directlly used range[0].startDate.toISOString().slice(0, 10) the output was yesterday date so I used
//           //adjustedDate.toISOString().slice(0, 10) to get start date
//           const data = new FormData();
//           data.append("document", JSON.stringify(values));
//           data.append("searchValue", JSON.stringify(searchValue));
//           data.append("startDate", adjustedDate.toISOString().slice(0, 10)); // Add start date
//           data.append("endDate", adjustedDates.toISOString().slice(0, 10)); // Add end date
//           const response = await axios.post("/billingpost", data, {
//             //send token header to authorize the api
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "multipart/form-data",
//             },
//             params: {
//               hospitalcodes: userHospitalcode, // Include the hospitalcode in the query parameters
//               userrole: userrole1, // Include the userrole in the query parameters
//             },
//           });
//           if (response.data.length === 0) {
//             // If the response data is an empty array, display a message
//             alert("No data found");
//             setDataSupply(response.data);
//           } else {
//             // Otherwise, set the dataSupply state with the response data
//             console.log(response.data);
//             setDataSupply(response.data);
//           }
//           }
//         } catch (err) {

//         }
//         action.resetForm();
//       },

//     });
//   const [totalPrice, setTotalPrice] = useState(0);
//   const [dataSupply, setDataSupply] = useState([]);

//   // date state
//   const [range, setRange] = useState([
//     {
//       endDate: new Date(),
//       startDate: subDays(new Date(), 7),
//       key: 'selection'
//     }
//   ])
//   console.log(range)
//   // open close
//   const [open, setOpen] = useState(false)
//   // get the target element to toggle
//   const refOne = useRef(null)
//   useEffect(() => {
//     //loadHospitalcode();
//     if (!localStorage.getItem('jwtToken')) {
//       return history.push('/');

//     }
//     // event listeners
//     document.addEventListener("keydown", hideOnEscape, true)
//     document.addEventListener("click", hideOnClickOutside, true)
//   }, [])
//   // hide dropdown on ESC press
//   const hideOnEscape = (e) => {
//     // console.log(e.key)
//     if (e.key === "Escape") {
//       setOpen(false)
//     }
//   }
//   // Hide dropdown on outside click
//   const hideOnClickOutside = (e) => {
//     // console.log(refOne.current)
//     // console.log(e.target)
//     if (refOne.current && !refOne.current.contains(e.target)) {
//       setOpen(false)
//     }
//   }
//   //function is for downloding the table data
//   const handleDownload = (event) => {
//     event.preventDefault();
//     // Create a new workbook and worksheet
//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.table_to_sheet(document.getElementById('supplyitem'));//need to provide the id of specific table here (id is supplyitem) .

//     // Add the worksheet to the workbook
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

//     // Convert the workbook to an Excel file
//     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

//     // Save the file using FileSaver.js
//     const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//     saveAs(data, 'Billing_report.xlsx');
//   };
//   const currentDomain = window.location.hostname;
//   return (
//     <div>
// <Helmet>
//         <title>Billing Report | {currentDomain} | Hospital Management Software | Smart Solutions for Hospital Efficiency</title>
//       </Helmet>
//       <div className="">
//         <form onSubmit={handleSubmit}>
//           <div className="input-employeecontainer">
//           <div className="input-blockemployee">
//               <label htmlFor="date" className="input-labelemployee">
//                 Created on
//               </label>
//               <div className="calendarWrap">
//                 <input
//                   type="text"
//                   name="date"
//                   id="date"
//                   value={`${format(range[0].startDate, "dd/MM/yyyy")} to ${format(range[0].endDate, "dd/MM/yyyy")}`}
//                   readOnly
//                   onClick={() => setOpen(open => !open)}
//                 />
//                 <div ref={refOne}>
//                   {open &&
//                     <DateRangePicker
//                       onChange={item => setRange([item.selection])}
//                       editableDateInputs={true}
//                       moveRangeOnFirstSelection={false}
//                       ranges={range}
//                       months={1}
//                       direction="vertical"
//                       className="calendarElement"
//                     />
//                   }
//                 </div>
//               </div>
//             </div>
//             <div className="input-blockemployee">
//               <label htmlFor="idforrequisition" className="input-labelemployee">
//                Billing Number
//               </label>
//               <div className="inputerroremployee">
//                 {/* <input
//                   type="text"
//                   autoComplete="off"
//                   name="idforrequisition"
//                   id="idforrequisition"
//                   value={values.idforrequisition}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >

//                 </input> */}
//                  <Billingsearch onSearchChange={handleSearchChange} />
//               </div>
//             </div>
//             {/* <div className="input-blockemployee">
//               <label htmlFor="opdtype" className="input-labelemployee">
//                OPD type
//               </label>
//               <div className="inputerroremployee">
//                 <select
//                   type="text"
//                   autoComplete="off"
//                   name="opdtype"
//                   id="opdtype"
//                   value={values.opdtype}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >
//                  <option>Select OPD type</option>
//                  <option>New</option>
//                  <option>Visit</option>
//                 </select>
//               </div>
//             </div> */}
//           </div>
//           <div className="input-employeecontainer">

//             {isAuthorized ? (  <div className="input-blockemployee">
//               <label htmlFor="hospitalcode" className="input-labelemployee">
//                Hospital code
//               </label>
//                 <div className="inputerroremployee">
//                 <HospitalCodeSearch onSearchItem={onSearchItems} />
//                 {/* <select
//                   type="text"
//                   autoComplete="off"
//                   name="hospitalcode"
//                   id="hospitalcode"
//                   value={values.hospitalcode}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >
//                   <option>Select Hospitalcode </option>
//                   {data.map(data => (
//                     <option value={data.hospitalcode} key={data.Id} >{data.hospitalcode}</option>
//                   ))
//                   }
//                 </select> */}
//               </div>
//             </div> ) : null}
//           </div>

//           <div className='buttonDisplay'>
//             <button className="allbuttonget">Get Details</button>
//             <FaFileDownload className='download' onClick={handleDownload}/>
//           </div>
//           <br />
//           <div className='container2'>
//             <table id="supplyitem">
//               <thead>
//                 <tr>
//                   <th>Billing Number</th>
//                   <th>Patient Id</th>
//                   <th>Patient Name </th>
//                   <th>Bill Amount</th>
//                   <th>Bill Date</th>
//                   <th>Description</th>
//                   {isAuthorized ? ( <th>Hospital Code</th>) : null}
//                   {/* <th>Months</th>
//                   <th>Years</th>  */}
//                 </tr>
//               </thead>

//               <tbody>

//                 {filterAndConcatenateChargenames(dataSupply).map((value, key) => (
//                     <tr key={key}>
//                     <td>{value.billnumber}</td>
//                            <td>{value.patientid}</td>
//                            <td>{value.patientname}</td>
//                            <td>{value.subtotal}</td>
//                            <td>{value.createdon}</td>
//                            <td>{value.chargename}</td>
//                            {isAuthorized ? (<td>{value.hospitalcode}</td>) : null}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </form>
//       </div>
//     </div>
//   )
// }

// export default BillingReport

// import { useEffect, useRef, useState } from "react";
// import { useFormik } from "formik";
// import { Helmet } from "react-helmet";
// import axios from "./../../helper/axios";
// import { useHistory } from "react-router-dom";
// import { DateRangePicker } from "react-date-range";
// import format from "date-fns/format";
// import { addDays } from "date-fns";
// import { subDays } from "date-fns";
// import "react-date-range/dist/styles.css";
// import "react-date-range/dist/theme/default.css";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx";
// import { GrDocumentDownload } from "react-icons/gr";
// import { FaFileDownload } from "react-icons/fa";
// import Apointmentsearch from "../../Component/Apointmentsearch";
// import { useUser } from "../../Provider";
// import Billingsearch from "../../Component/Billingsearch";
// import HospitalCodeSearch from "../../Component/HospitalCodeSearch";
// import { useToast } from "../ToastSystem";

// const initialValues = {
//   opdnumber: "",
//   opdtype: "",
//   hospitalcode: "",
// };

// const filterAndConcatenateChargenames = (data) => {
//   const uniqueBillnumbers = [];
//   const filteredData = [];

//   data.forEach((item) => {
//     const {
//       billnumber,
//       chargename,
//       patientid,
//       patientname,
//       subtotal,
//       createdon,
//       hospitalcode,
//     } = item;

//     if (!uniqueBillnumbers.includes(billnumber)) {
//       uniqueBillnumbers.push(billnumber);
//       filteredData.push({
//         billnumber,
//         chargename,
//         patientid,
//         patientname,
//         subtotal,
//         createdon,
//         hospitalcode,
//       });
//     } else {
//       const index = filteredData.findIndex(
//         (el) => el.billnumber === billnumber
//       );
//       if (index !== -1) {
//         filteredData[index].chargename += `, ${chargename}`;
//       }
//     }
//   });

//   return filteredData;
// };

// const BillingReport = () => {
//   const history = useHistory();
//   const {
//     user,
//     userHospitalcode,
//     userrole1,
//     isAuthRole,
//     isAuthorized,
//     gettokenId,
//     token,
//   } = useUser();
//   const { showSuccess, showError, showInfo } = useToast();

//   const [searchValue, setSearchValue] = useState("");
//   const [totalPrice, setTotalPrice] = useState(0);
//   const [dataSupply, setDataSupply] = useState([]);
//   const [range, setRange] = useState([
//     {
//       endDate: new Date(),
//       startDate: subDays(new Date(), 7),
//       key: "selection",
//     },
//   ]);
//   const [open, setOpen] = useState(false);
//   const refOne = useRef(null);

//   const handleSearchChange = (searchTerm) => {
//     console.log(searchTerm);
//     setSearchValue(searchTerm);
//   };

//   const onSearchItems = (searchTerm) => {
//     console.log("------", searchTerm);
//     setValues({
//       ...values,
//       hospitalcode: searchTerm.hospitalcode,
//     });
//   };

//   const {
//     values,
//     errors,
//     touched,
//     handleBlur,
//     handleChange,
//     handleReset,
//     handleSubmit,
//     setValues,
//   } = useFormik({
//     initialValues,
//     onSubmit: async (values, action) => {
//       try {
//         if (userHospitalcode !== undefined && userrole1 !== undefined) {
//           const startDate = range[0].startDate;
//           const endDate = range[0].endDate;
//           const timezoneOffset = startDate.getTimezoneOffset() * 60000;
//           const adjustedDate = new Date(startDate.getTime() - timezoneOffset);
//           const adjustedDates = new Date(endDate.getTime() - timezoneOffset);
//           console.log(adjustedDate.toISOString().slice(0, 10));

//           const data = new FormData();
//           data.append("document", JSON.stringify(values));
//           data.append("searchValue", JSON.stringify(searchValue));
//           data.append("startDate", adjustedDate.toISOString().slice(0, 10));
//           data.append("endDate", adjustedDates.toISOString().slice(0, 10));

//           const response = await axios.post("/billingpost", data, {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "multipart/form-data",
//             },
//             params: {
//               hospitalcodes: userHospitalcode,
//               userrole: userrole1,
//             },
//           });

//           if (response.data.length === 0) {
//             showInfo("No billing data found for the selected criteria.");
//             setDataSupply(response.data);
//           } else {
//             console.log(response.data);
//             setDataSupply(response.data);
//             showSuccess(
//               `Successfully loaded ${response.data.length} billing records!`
//             );
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching billing report:", err);

//         if (err.response?.status === 400) {
//           showError("Invalid request. Please check your inputs.");
//         } else if (err.response?.status === 403) {
//           showError("You don't have permission to access this report.");
//         } else if (err.response?.status >= 500) {
//           showError("Server error occurred. Please try again later.");
//         } else if (err.request) {
//           showError(
//             "Network error. Please check your connection and try again."
//           );
//         } else {
//           showError("Failed to load billing report. Please try again.");
//         }
//       }
//       action.resetForm();
//     },
//   });

//   console.log(range);

//   useEffect(() => {
//     if (!localStorage.getItem("jwtToken")) {
//       return history.push("/");
//     }
//     document.addEventListener("keydown", hideOnEscape, true);
//     document.addEventListener("click", hideOnClickOutside, true);

//     return () => {
//       document.removeEventListener("keydown", hideOnEscape, true);
//       document.removeEventListener("click", hideOnClickOutside, true);
//     };
//   }, []);

//   const hideOnEscape = (e) => {
//     if (e.key === "Escape") {
//       setOpen(false);
//     }
//   };

//   const hideOnClickOutside = (e) => {
//     if (refOne.current && !refOne.current.contains(e.target)) {
//       setOpen(false);
//     }
//   };

//   const handleDownload = (event) => {
//     event.preventDefault();

//     try {
//       if (dataSupply.length === 0) {
//         showError("No data available to download!");
//         return;
//       }

//       const workbook = XLSX.utils.book_new();
//       const worksheet = XLSX.utils.table_to_sheet(
//         document.getElementById("supplyitem")
//       );

//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

//       const excelBuffer = XLSX.write(workbook, {
//         bookType: "xlsx",
//         type: "array",
//       });

//       const data = new Blob([excelBuffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });
//       saveAs(data, "Billing_report.xlsx");

//       showSuccess("Billing report downloaded successfully!");
//     } catch (error) {
//       console.error("Error downloading report:", error);
//       showError("Failed to download report. Please try again.");
//     }
//   };

//   const currentDomain = window.location.hostname;

//   return (
//     <div>
//       <Helmet>
//         <title>
//           Billing Report | {currentDomain} | Hospital Management Software |
//           Smart Solutions for Hospital Efficiency
//         </title>
//       </Helmet>
//       <div className="">
//         <form onSubmit={handleSubmit}>
//           <div className="input-employeecontainer">
//             <div className="input-blockemployee">
//               <label htmlFor="date" className="input-labelemployee">
//                 Created on
//               </label>
//               <div className="calendarWrap">
//                 <input
//                   type="text"
//                   name="date"
//                   id="date"
//                   value={`${format(
//                     range[0].startDate,
//                     "dd/MM/yyyy"
//                   )} to ${format(range[0].endDate, "dd/MM/yyyy")}`}
//                   readOnly
//                   onClick={() => setOpen((open) => !open)}
//                 />
//                 <div ref={refOne}>
//                   {open && (
//                     <DateRangePicker
//                       onChange={(item) => setRange([item.selection])}
//                       editableDateInputs={true}
//                       moveRangeOnFirstSelection={false}
//                       ranges={range}
//                       months={1}
//                       direction="vertical"
//                       className="calendarElement"
//                     />
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div className="input-blockemployee">
//               <label htmlFor="idforrequisition" className="input-labelemployee">
//                 Billing Number
//               </label>
//               <div className="inputerroremployee">
//                 <Billingsearch onSearchChange={handleSearchChange} />
//               </div>
//             </div>
//           </div>
//           <div className="input-employeecontainer">
//             {isAuthorized ? (
//               <div className="input-blockemployee">
//                 <label htmlFor="hospitalcode" className="input-labelemployee">
//                   Hospital code
//                 </label>
//                 <div className="inputerroremployee">
//                   <HospitalCodeSearch onSearchItem={onSearchItems} />
//                 </div>
//               </div>
//             ) : null}
//           </div>

//           <div className="buttonDisplay">
//             <button className="allbuttonget">Get Details</button>
//             <FaFileDownload className="download" onClick={handleDownload} />
//           </div>
//           <br />
//           <div className="container2">
//             <table id="supplyitem">
//               <thead>
//                 <tr>
//                   <th>Billing Number</th>
//                   <th>Patient Id</th>
//                   <th>Patient Name </th>
//                   <th>Bill Amount</th>
//                   <th>Bill Date</th>
//                   <th>Description</th>
//                   {isAuthorized ? <th>Hospital Code</th> : null}
//                 </tr>
//               </thead>

//               <tbody>
//                 {filterAndConcatenateChargenames(dataSupply).map(
//                   (value, key) => (
//                     <tr key={key}>
//                       <td>{value.billnumber}</td>
//                       <td>{value.patientid}</td>
//                       <td>{value.patientname}</td>
//                       <td>{value.subtotal}</td>
//                       <td>{value.createdon}</td>
//                       <td>{value.chargename}</td>
//                       {isAuthorized ? <td>{value.hospitalcode}</td> : null}
//                     </tr>
//                   )
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default BillingReport;

import { useEffect, useRef, useState, useCallback } from "react";
import { useFormik } from "formik";
import { Helmet } from "react-helmet";
import axios from "./../../helper/axios";
import { useHistory } from "react-router-dom";
import { DateRangePicker } from "react-date-range";
import format from "date-fns/format";
import { subDays } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { FaFileDownload } from "react-icons/fa";
import Billingsearch from "../../Component/Billingsearch";
import { useUser } from "../../Provider";
import HospitalCodeSearch from "../../Component/HospitalCodeSearch";
import { useToast } from "../ToastSystem";

const initialValues = { opdnumber: "", opdtype: "", hospitalcode: "" };

// Merge rows with the same billnumber, concatenating chargeNames
const mergeByBillnumber = (data) => {
  const map = new Map();
  for (const item of data) {
    if (map.has(item.billnumber)) {
      map.get(item.billnumber).chargename += `, ${item.chargename}`;
    } else {
      map.set(item.billnumber, { ...item });
    }
  }
  return [...map.values()];
};

const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount);

const toLocalISO = (date) => {
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 10);
};

// ─── Report HTML generator ─────────────────────────────────────────────────
const generateReportHTML = ({
  data,
  startDate,
  endDate,
  hospitalcode,
  isAuthorized,
}) => {
  const merged = mergeByBillnumber(data);
  const totalAmount = merged.reduce(
    (sum, r) => sum + Number(r.subtotal || 0),
    0,
  );
  const totalBills = merged.length;
  const avgBill = totalBills ? totalAmount / totalBills : 0;

  // Daily breakdown
  const dailyMap = {};
  for (const row of merged) {
    const day = row.createdon?.slice(0, 10) || "Unknown";
    dailyMap[day] = (dailyMap[day] || 0) + Number(row.subtotal || 0);
  }
  const dailyEntries = Object.entries(dailyMap).sort(([a], [b]) =>
    a.localeCompare(b),
  );
  const todayKey = new Date().toISOString().slice(0, 10);
  const todayTotal = dailyMap[todayKey] || 0;
  const maxDaily = Math.max(...Object.values(dailyMap), 1);

  const barsHTML = dailyEntries
    .map(([day, amt]) => {
      const pct = Math.round((amt / maxDaily) * 100);
      return `<div style="display:flex;align-items:center;gap:10px;margin-bottom:6px;">
        <span style="width:90px;text-align:right;font-size:12px;color:#6b7280;">${day}</span>
        <div style="flex:1;background:#f3f4f6;border-radius:3px;height:8px;">
          <div style="width:${pct}%;background:#1d4ed8;height:8px;border-radius:3px;"></div>
        </div>
        <span style="width:90px;font-size:12px;font-weight:500;">${formatCurrency(amt)}</span>
      </div>`;
    })
    .join("");

  const rowsHTML = merged
    .map(
      (r, i) => `<tr style="background:${i % 2 === 0 ? "#fff" : "#f9fafb"}">
        <td style="padding:9px 12px;border-bottom:1px solid #e5e7eb;">${r.billnumber}</td>
        <td style="padding:9px 12px;border-bottom:1px solid #e5e7eb;">${r.patientid}</td>
        <td style="padding:9px 12px;border-bottom:1px solid #e5e7eb;">${r.patientname}</td>
        <td style="padding:9px 12px;border-bottom:1px solid #e5e7eb;font-size:12px;color:#6b7280;">${r.chargename}</td>
        <td style="padding:9px 12px;border-bottom:1px solid #e5e7eb;">${r.createdon}</td>
        <td style="padding:9px 12px;border-bottom:1px solid #e5e7eb;text-align:right;font-weight:500;">${formatCurrency(r.subtotal)}</td>
        ${isAuthorized ? `<td style="padding:9px 12px;border-bottom:1px solid #e5e7eb;">${r.hospitalcode}</td>` : ""}
      </tr>`,
    )
    .join("");

  const generated = format(new Date(), "dd MMM yyyy, HH:mm");

  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8"/>
  <title>Billing Report ${format(new Date(startDate), "dd MMM yyyy")}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'Inter', sans-serif; font-size: 13px; color: #111827; background: #f9fafb; }
    .page { max-width: 900px; margin: 0 auto; background: #fff; min-height: 100vh; }
    .top-bar { background: #1d4ed8; color: #fff; padding: 18px 32px; display: flex; justify-content: space-between; align-items: center; }
    .top-bar h1 { font-size: 18px; font-weight: 600; letter-spacing: -0.02em; }
    .top-bar p { font-size: 12px; opacity: 0.75; margin-top: 2px; }
    .top-bar-right { text-align: right; font-size: 12px; opacity: 0.8; line-height: 1.8; }
    .content { padding: 24px 32px; }
    .kpi-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 12px; margin-bottom: 24px; }
    .kpi { background: #eff6ff; border-radius: 8px; padding: 14px 16px; border: 1px solid #dbeafe; }
    .kpi-label { font-size: 11px; color: #6b7280; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px; }
    .kpi-value { font-size: 20px; font-weight: 600; color: #1e3a8a; }
    .kpi-sub { font-size: 11px; color: #9ca3af; margin-top: 3px; }
    .section { border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; margin-bottom: 20px; }
    .section-header { padding: 10px 16px; background: #f9fafb; border-bottom: 1px solid #e5e7eb; display: flex; justify-content: space-between; }
    .section-title { font-size: 12px; font-weight: 600; color: #374151; text-transform: uppercase; letter-spacing: 0.05em; }
    .section-body { padding: 14px 16px; }
    table { width: 100%; border-collapse: collapse; }
    th { padding: 8px 12px; text-align: left; font-size: 11px; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.04em; background: #f9fafb; border-bottom: 1px solid #e5e7eb; }
    th:last-child, td:last-child { text-align: right; }
    .footer { background: #f9fafb; border-top: 1px solid #e5e7eb; padding: 12px 16px; display: flex; justify-content: flex-end; gap: 32px; }
    .foot-item { text-align: right; }
    .foot-label { font-size: 11px; color: #9ca3af; }
    .foot-value { font-size: 14px; font-weight: 600; color: #111827; }
    .print-note { text-align: center; font-size: 11px; color: #9ca3af; padding: 20px; }
    @media print {
      body { background: #fff; }
      .page { max-width: 100%; }
      .print-note { display: none; }
    }
  </style>
</head>
<body>
<div class="page">
  <div class="top-bar">
    <div>
      <h1>Billing Collection Report</h1>
      <p>${format(new Date(startDate), "dd MMM yyyy")} &ndash; ${format(new Date(endDate), "dd MMM yyyy")}</p>
    </div>
    <div class="top-bar-right">
      ${isAuthorized && hospitalcode ? `Hospital: ${hospitalcode}<br>` : ""}
      Generated: ${generated}<br>
    
    </div>
  </div>

  <div class="content">
    <div class="kpi-grid">
      <div class="kpi"><div class="kpi-label">Total collection</div><div class="kpi-value">${formatCurrency(totalAmount)}</div><div class="kpi-sub">Period total</div></div>
      <div class="kpi"><div class="kpi-label">Today's collection</div><div class="kpi-value">${formatCurrency(todayTotal)}</div><div class="kpi-sub">${format(new Date(), "dd MMM yyyy")}</div></div>
      <div class="kpi"><div class="kpi-label">Total bills</div><div class="kpi-value">${totalBills}</div><div class="kpi-sub">Unique bill numbers</div></div>
      <div class="kpi"><div class="kpi-label">Avg bill value</div><div class="kpi-value">${formatCurrency(avgBill)}</div><div class="kpi-sub">Per billing record</div></div>
    </div>

    <div class="section">
      <div class="section-header"><span class="section-title">Daily collection breakdown</span></div>
      <div class="section-body">${barsHTML || "<p style='color:#9ca3af;font-size:12px;'>No data</p>"}</div>
    </div>

    <div class="section">
      <div class="section-header">
        <span class="section-title">Billing records</span>
        <span style="font-size:11px;color:#9ca3af;">${totalBills} records</span>
      </div>
      <table>
        <thead>
          <tr>
            <th>Bill no.</th><th>Patient ID</th><th>Patient name</th>
            <th>Services</th><th>Date</th><th>Amount</th>
            ${isAuthorized ? "<th>Hospital</th>" : ""}
          </tr>
        </thead>
        <tbody>${rowsHTML}</tbody>
      </table>
      <div class="footer">
        <div class="foot-item"><div class="foot-label">Total bills</div><div class="foot-value">${totalBills}</div></div>
        <div class="foot-item"><div class="foot-label">Total collection</div><div class="foot-value">${formatCurrency(totalAmount)}</div></div>
      </div>
    </div>
  </div>
  <p class="print-note">To save as PDF: File &rarr; Print &rarr; Save as PDF</p>
</div>
</body>
</html>`;
};

// ─── Main component ────────────────────────────────────────────────────────
const BillingReport = () => {
  const history = useHistory();
  const { userHospitalcode, userrole1, isAuthorized, token } = useUser();
  const { showSuccess, showError, showInfo } = useToast();

  const [searchValue, setSearchValue] = useState("");
  const [dataSupply, setDataSupply] = useState([]);
  const [range, setRange] = useState([
    {
      endDate: new Date(),
      startDate: subDays(new Date(), 7),
      key: "selection",
    },
  ]);
  const [open, setOpen] = useState(false);
  const refOne = useRef(null);

  useEffect(() => {
    if (!localStorage.getItem("jwtToken")) return history.push("/");
    const hideOnEscape = (e) => e.key === "Escape" && setOpen(false);
    const hideOnClickOutside = (e) =>
      refOne.current && !refOne.current.contains(e.target) && setOpen(false);
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
    return () => {
      document.removeEventListener("keydown", hideOnEscape, true);
      document.removeEventListener("click", hideOnClickOutside, true);
    };
  }, []);

  const { values, handleReset, handleSubmit, setValues } = useFormik({
    initialValues,
    onSubmit: async (values, action) => {
      try {
        if (!userHospitalcode || !userrole1) return;
        const data = new FormData();
        data.append("document", JSON.stringify(values));
        data.append("searchValue", JSON.stringify(searchValue));
        data.append("startDate", toLocalISO(range[0].startDate));
        data.append("endDate", toLocalISO(range[0].endDate));

        const response = await axios.post("/billingpost", data, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          params: { hospitalcodes: userHospitalcode, userrole: userrole1 },
        });

        if (response.data.length === 0) {
          showInfo("No billing data found for the selected criteria.");
        } else {
          showSuccess(`Loaded ${response.data.length} billing records.`);
        }
        setDataSupply(response.data);
      } catch (err) {
        const status = err.response?.status;
        if (status === 400)
          showError("Invalid request. Please check your inputs.");
        else if (status === 403)
          showError("You don't have permission to access this report.");
        else if (status >= 500)
          showError("Server error. Please try again later.");
        else if (err.request)
          showError("Network error. Check your connection.");
        else showError("Failed to load billing report.");
      }
      action.resetForm();
    },
  });

  const handleDownload = useCallback(
    (e) => {
      e.preventDefault();
      if (!dataSupply.length) {
        showError("No data to download. Fetch records first.");
        return;
      }
      try {
        const html = generateReportHTML({
          data: dataSupply,
          startDate: toLocalISO(range[0].startDate),
          endDate: toLocalISO(range[0].endDate),
          hospitalcode: values.hospitalcode,
          isAuthorized,
        });
        const blob = new Blob([html], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Billing_Report_${toLocalISO(range[0].startDate)}_to_${toLocalISO(range[0].endDate)}.html`;
        a.click();
        URL.revokeObjectURL(url);
        showSuccess(
          "Report downloaded! Open in browser and print → Save as PDF to share.",
        );
      } catch (err) {
        showError("Failed to generate report.");
      }
    },
    [dataSupply, range, values.hospitalcode, isAuthorized],
  );

  const currentDomain = window.location.hostname;
  const merged = mergeByBillnumber(dataSupply);

  return (
    <div>
      <Helmet>
        <title>
          Billing Report | {currentDomain} | Hospital Management Software
        </title>
      </Helmet>
      <form onSubmit={handleSubmit}>
        <div className="input-employeecontainer">
          <div className="input-blockemployee">
            <label htmlFor="date" className="input-labelemployee">
              Created on
            </label>
            <div className="calendarWrap">
              <input
                type="text"
                name="date"
                id="date"
                value={`${format(range[0].startDate, "dd/MM/yyyy")} to ${format(range[0].endDate, "dd/MM/yyyy")}`}
                readOnly
                onClick={() => setOpen((o) => !o)}
              />
              <div ref={refOne}>
                {open && (
                  <DateRangePicker
                    onChange={(item) => setRange([item.selection])}
                    editableDateInputs
                    moveRangeOnFirstSelection={false}
                    ranges={range}
                    months={1}
                    direction="vertical"
                    className="calendarElement"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="input-blockemployee">
            <label className="input-labelemployee">Billing Number</label>
            <Billingsearch onSearchChange={(v) => setSearchValue(v)} />
          </div>
        </div>

        {isAuthorized && (
          <div className="input-employeecontainer">
            <div className="input-blockemployee">
              <label htmlFor="hospitalcode" className="input-labelemployee">
                Hospital Code
              </label>
              <HospitalCodeSearch
                onSearchItem={(item) =>
                  setValues((v) => ({ ...v, hospitalcode: item.hospitalcode }))
                }
              />
            </div>
          </div>
        )}

        <div className="buttonDisplay">
          <button type="submit" className="allbuttonget">
            Get Details
          </button>
          <FaFileDownload
            className="download"
            onClick={handleDownload}
            title="Download professional report"
            style={{ cursor: "pointer" }}
          />
        </div>

        <div className="container2">
          <table id="supplyitem">
            <thead>
              <tr>
                <th>Billing Number</th>
                <th>Patient ID</th>
                <th>Patient Name</th>
                <th>Bill Amount</th>
                <th>Bill Date</th>
                <th>Description</th>
                {isAuthorized && <th>Hospital Code</th>}
              </tr>
            </thead>
            <tbody>
              {merged.map((row, i) => (
                <tr key={i}>
                  <td>{row.billnumber}</td>
                  <td>{row.patientid}</td>
                  <td>{row.patientname}</td>
                  <td>{row.subtotal}</td>
                  <td>{row.createdon}</td>
                  <td>{row.chargename}</td>
                  {isAuthorized && <td>{row.hospitalcode}</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </form>
    </div>
  );
};

export default BillingReport;
